import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Plus } from "lucide-react";

/**
 * FaqList, card-style accordion with soft elevation and an animated open state.
 */
export default function FaqList({ items, testIdPrefix = "faq" }) {
  return (
    <Accordion
      type="single"
      collapsible
      className="w-full space-y-4"
      data-testid={`${testIdPrefix}-accordion`}
    >
      {items.map((item, idx) => (
        <AccordionItem
          key={idx}
          value={`item-${idx}`}
          className="card-elevated rounded-2xl overflow-hidden transition-all duration-300 data-[state=open]:shadow-card data-[state=open]:border-clay-200/70"
          data-testid={`${testIdPrefix}-item-${idx}`}
        >
          <AccordionTrigger className="group px-6 sm:px-7 py-5 hover:no-underline text-left [&>svg]:hidden">
            <div className="flex items-center justify-between gap-5 w-full">
              <span className="font-serif text-xl sm:text-2xl text-forest-900 leading-snug tracking-tight">
                {item.q}
              </span>
              <span className="shrink-0 h-10 w-10 rounded-full bg-sage-50 text-sage-700 flex items-center justify-center transition-all duration-300 group-hover:bg-sage-100 group-data-[state=open]:bg-clay-600 group-data-[state=open]:text-sand-50 group-data-[state=open]:rotate-45">
                <Plus size={18} strokeWidth={2} />
              </span>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-6 sm:px-7 pb-7 pr-12 text-forest-700 text-[17px] leading-[1.85]">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
